export enum ActionStatus {
  PLANNED = "PLANNED",
  COMPLETE = "COMPLETE",
  IN_PROGRESS = "IN PROGRESS",
  REMOVED = "REMOVED",
}
